import React from "react";

function UserNameIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0351 9.86441C10.9443 9.85533 10.8354 9.85533 10.7356 9.86441C8.57577 9.79181 6.8606 8.02218 6.8606 5.84418C6.8606 3.62081 8.65745 1.81488 10.8899 1.81488C13.1133 1.81488 14.9192 3.62081 14.9192 5.84418C14.9101 8.02218 13.1949 9.79181 11.0351 9.86441Z"
        stroke="#424242"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.49758 13.2131C4.30143 14.6832 4.30143 17.079 6.49758 18.5401C8.9932 20.2099 13.086 20.2099 15.5817 18.5401C17.7778 17.0699 17.7778 14.6741 15.5817 13.2131C13.0951 11.5523 9.00228 11.5523 6.49758 13.2131Z"
        stroke="#424242"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default UserNameIcon;
